import {History} from 'history';
import fetch from 'node-fetch';
import {ServicesErrors, UserApi} from '../../constants';
import {handleResponse, handleCommonErrorResponse, determineErrorLevelForSentry} from '../../utils';
import * as Sentry from '@sentry/browser';

export function changeUserName(userName = '', history: History): Promise<void> {
  let userData = {
    name: userName,
  }

  const requestOptions = {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(userData)
  };

  return fetch(UserApi, requestOptions)
    .then(handleResponse)
    .catch(error => {
      const errorLevel = determineErrorLevelForSentry(error);

      Sentry.configureScope((scope) => {
        scope.setLevel(errorLevel);
      })

      Sentry.addBreadcrumb({
        category: 'user profile',
        message: 'Endpoint ' + UserApi,
        data: {
          error: error,
        },
        level: errorLevel,
      });
      Sentry.captureMessage(`${ServicesErrors.user.changeUserNameFailed} with ${error.message}`, errorLevel);
      return handleCommonErrorResponse(error, history)
    });
}
